import PARCIcon from '../../public/assets/PARC.svg';
import { HStack, Text } from 'ui_2';
import { usePuzzleGameContext } from '@src/providers/puzzleProvider';

export const PARCBalance = ({ gameActive }: { gameActive: boolean }) => {
  const { parcBalance } = usePuzzleGameContext();

  if (parcBalance !== undefined) {
    return (
      <HStack
        className={`h-fit items-center rounded-[10px] ${
          gameActive ? 'bg-[#2D2613]' : 'bg-[#E1BF6033]'
        } pl-1 pr-4`}
      >
        <img src={PARCIcon} width={44} height={44} />
        <Text family='space' font={'lg'} className='text-[#FFE9A8]'>
          {parcBalance} PARC
        </Text>
      </HStack>
    );
  }
};

export const AleoBalance = () => {
  const { aleoBalance, aleoBalanceTotal } = usePuzzleGameContext();

  if (aleoBalance !== undefined) {
    return (
      <HStack className='items-center rounded-[10px] bg-[#E1BF6033] px-4'>
        {aleoBalance.iconURL && (
          <img src={aleoBalance.iconURL} width={44} height={44} />
        )}
        <Text family='space' font={'lg'} className='text-[#FFE9A8]'>
          {aleoBalanceTotal} Aleo
        </Text>
      </HStack>
    );
  }
};
